import superagent from 'superagent';
import config from '../config/config';
import store from '../store';
import vuetify from '../plugins/vuetify';

class ApiUtil {
  constructor() {
    this.token = null;
    this.url = config.API_URL;
    // Register superagent middleware. This function will trigger on each request.
    this.api = superagent.agent().use((request) => {
      if (this.token) {
        request.set('token', this.token);
      }
    });
  }

  setToken(token) {
    this.token = token;
  }

  async login(username, password) {
    const data = { username, password };
    const result = await this.api.post(`${this.url}/user/login`).send(data);
    return result.body.data;
  }

  async logout() {
    const data = { token: this.token };
    const result = await this.api.post(`${this.url}/user/logout`).send(data);
    return result.body.data;
  }

  async getAllUser() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/user`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async deleteUserById(data) {
    let result = null;
    try {
      const response = await this.api.del(`${this.url}/user`).send(data);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      } else {
        store.dispatch('setSnackbar', { text: vuetify.framework.lang.t('$vuetify.deletedSuccessfully', vuetify.framework.lang.t('$vuetify.user')), mode: 'success' });
      }
      return result;
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async saveUser(data) {
    let result = null;
    try {
      const response = await this.api.post(`${this.url}/user`).send(data);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    } else {
      store.dispatch('setSnackbar', { text: vuetify.framework.lang.t('$vuetify.savedSuccessfully', vuetify.framework.lang.t('$vuetify.user')), mode: 'success' });
    }
    return result;
  }

  async getAllGroup() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/group`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async deleteGroupById(data) {
    let result = null;
    try {
      const response = await this.api.del(`${this.url}/group`).send(data);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      } else {
        store.dispatch('setSnackbar', { text: vuetify.framework.lang.t('$vuetify.deletedSuccessfully', vuetify.framework.lang.t('$vuetify.group')), mode: 'success' });
      }
      return result;
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async saveGroup(data) {
    let result = null;
    try {
      const response = await this.api.post(`${this.url}/group`).send(data);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    } else {
      store.dispatch('setSnackbar', { text: vuetify.framework.lang.t('$vuetify.savedSuccessfully', vuetify.framework.lang.t('$vuetify.group')), mode: 'success' });
    }
    return result;
  }

  async getAllPermission() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/permission`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async getAllPreferences() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/user/preferences`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async savePreferences(data) {
    let result = null;
    try {
      const response = await this.api.post(`${this.url}/user/preferences`).send(data);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    } else {
      store.dispatch('setSnackbar', { text: vuetify.framework.lang.t('$vuetify.savedSuccessfully', vuetify.framework.lang.t('$vuetify.preferences')), mode: 'success' });
    }
    return result;
  }

  async getAllForms() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/form`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async deleteFormById(data) {
    let result = null;
    try {
      const response = await this.api.del(`${this.url}/form`).send(data);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      } else {
        store.dispatch('setSnackbar', { text: vuetify.framework.lang.t('$vuetify.deletedSuccessfully', vuetify.framework.lang.t('$vuetify.form.name')), mode: 'success' });
      }
      return result;
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async saveForm(data) {
    let result = null;
    try {
      const response = await this.api.post(`${this.url}/form`).send(data);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    } else {
      store.dispatch('setSnackbar', { text: vuetify.framework.lang.t('$vuetify.savedSuccessfully', vuetify.framework.lang.t('$vuetify.form.name')), mode: 'success' });
    }
    return result;
  }

  async saveFormList(data) {
    let result = null;
    try {
      const response = await this.api.post(`${this.url}/form-list`).send(data);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    } else {
      store.dispatch('setSnackbar', { text: vuetify.framework.lang.t('$vuetify.savedSuccessfully', vuetify.framework.lang.t('$vuetify.form.name')), mode: 'success' });
    }
    return result;
  }

  async getDailySumStat(inputId = null) {
    let result = null;
    try {
      const inputIdStr = (inputId !== null) ? inputId : '';
      const response = await this.api.get(`${this.url}/form-sum/daily/${inputIdStr}`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async getWeeklySumStat(inputId = null) {
    let result = null;
    try {
      const inputIdStr = (inputId !== null) ? inputId : '';
      const response = await this.api.get(`${this.url}/form-sum/weekly/${inputIdStr}`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async getMonthlySumStat(inputId = null) {
    let result = null;
    try {
      const inputIdStr = (inputId !== null) ? inputId : '';
      const response = await this.api.get(`${this.url}/form-sum/monthly/${inputIdStr}`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async getYearlySumStat(inputId = null) {
    let result = null;
    try {
      const inputIdStr = (inputId !== null) ? inputId : '';
      const response = await this.api.get(`${this.url}/form-sum/yearly/${inputIdStr}`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async getAllSumStat(inputId = null) {
    let result = null;
    try {
      const inputIdStr = (inputId !== null) ? inputId : '';
      const response = await this.api.get(`${this.url}/form-sum/all/${inputIdStr}`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }
}

export default new ApiUtil();
